function collectionSlider(selector, settings) {
  $(selector).slick(settings);
}
// /*  */
// $(".header__inline-menu details").on('mouseenter',function(e){
//  e.preventDefault();
//   let menu_wrapper = $(this).parents('.dropdown-menu'),
//       current_menu = $(this),
//       first_parent = $(this).parents('.header__submenu');
 
//     $('.dropdown-menu').removeClass('active-drawer');
//     $(this).parents('.dropdown-menu').addClass('active-drawer');

//     $('.dropdown-menu').each(function(){
//       let currentMenuBar = $(this);
//       if(currentMenuBar.hasClass('active-drawer')){
//       }else{
//         currentMenuBar.find('details').removeAttr('open');
//       }
//     });

//   if(menu_wrapper.hasClass('active-drawer')){
//     menu_wrapper.find('.header__submenu details').removeAttr('open');
//     $(this).attr('open','open');
//   }
// });

// $('.header-wrapper').on('mouseleave',function(e){
//   e.preventDefault();
//   $('details').removeAttr('open')
// });

$('.slide-arrow').on('click',function(){
  const section_id = $(this).attr('data-section');
  let left_arrow = $(`.slider-button--prev[aria-controls=Slider-${section_id}]`),
      right_arrow =  $(`.slider-button--next[aria-controls=Slider-${section_id}]`)

  if($(this).hasClass('left-slide-arrow')){
    left_arrow.click();
  }else{
    right_arrow.click();
  }

});

$('.product__arrow').on('click',function(){
    const section_id = $(this).attr('data-section-id');
    let activeThumbnail = $('.thumbnail-list__item button.thumbnail[aria-current="true"]'),
    nextThumbnail = activeThumbnail.parents('.thumbnail-list__item').next('.thumbnail-list__item').find('.thumbnail'),
    prevThumbnail= activeThumbnail.parents('.thumbnail-list__item').prev('.thumbnail-list__item').find('.thumbnail'),
    slides = document.querySelectorAll('.thumbnail');
    firstSlide = slides[0],
    lastSlide= slides[slides.length - 1];

    console.log(firstSlide,lastSlide);

    $('.product-left-arrow').removeClass('disabled');
    $('.product-rigth-arrow').removeClass('disabled');



    // if(prevThumbnail.length == 0){ 
    //   $('.product-left-arrow').addClass('disabled');
    // }
    
    // if(nextThumbnail.length == 0){
    //   $('.product-rigth-arrow').addClass('disabled');
    // }  


    if($(this).hasClass('product-rigth-arrow')){
        if(nextThumbnail.length > 0){
          nextThumbnail.click();
        }else{
          firstSlide.click();
        }
    }else{
      if(prevThumbnail.length > 0){
          prevThumbnail.click();
        }else{
          lastSlide.click();
        }
    }
});